import { ACCOUNT_LOCALE_LOCAL_STORAGE_KEY } from 'components/AccountLanguageSelect/constants';

const PATH_LOCALE_PATTERN = /^\/([a-z]{2}(?:_[A-Z]{2})?)\//;

export function getPathLocaleFromUrl(pathname = window.location.pathname): string | undefined {
  const match = pathname.match(PATH_LOCALE_PATTERN);
  if (!match?.[1]) {
    return undefined;
  }
  return match[1];
}

export function getReconnectLocale(): ConnectLocale {
  const venue = App.config.get('venue');
  const accountLocale = Wahanda.LocalStorage.get(ACCOUNT_LOCALE_LOCAL_STORAGE_KEY);
  const pathLocale = getPathLocaleFromUrl();

  const locale = pathLocale || accountLocale || venue?.locale || App.domainLocale || 'en';

  return locale as ConnectLocale;
}
